import axios from 'axios';

const list = (data) => axios.get('/pro/beltLine/list', data);
const save = (data) => axios.post('/pro/beltLine/save', data);
const del = (data) => axios.post('/pro/beltLine/delete', data);


export default {
  list,
  save,
  del,

}


